
import {
  defineComponent,
  ref,
  reactive,
  toRefs,
  onMounted,
  computed,
  watch,
  nextTick
} from 'vue'
import { useRoute } from 'vue-router'
import dataLoad from './dataLoad.vue'
import infoPanel from './infoPanel.vue'
import f10Api from '@/api/f10Api'

export default defineComponent({
  components: { dataLoad, infoPanel },
  props: {
    token: {
      type: String,
      default: function () {
        return ''
      }
    }
  },
  setup(props, context) {
    const pageData: any = reactive({
      list: [
        {
          key: 'Inst',
          title: '指数代码',
          content: ''
        },
        {
          key: 'Abbr',
          title: '指数名称',
          content: ''
        },
        {
          key: 'Name',
          title: '指数全称',
          content: ''
        },
        {
          key: 'ListedDate',
          title: '启用日期',
          content: ''
        }
      ],
      spinning: true
    })
    const route = useRoute()

    watch(
      () => (props as any).token,
      (val) => {
        if (val) {
          getBaseIndexF10Overview()
        }
      },
      { deep: true, immediate: true }
    )

    // 获取最新指数信息
    function getBaseIndexF10Overview() {
      const data: any = {}
      // 0：日期（默认），1：股票ID，2：评价，3：变动（1为首次,2为调高,3为调低,4为维持），4：目标价，5：机构，6：作者
      // 0:desc（默认）,1:asc
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code
      }
      data.headers = {
        token: (props as any).token
      }
      f10Api.baseIndexF10Overview(data).then((res: any) => {
        if (res.Code === 0) {
          pageData.list.forEach((item) => {
            item.content =
              item.key === 'ListedDate'
                ? window.moment(res.Data[item.key] * 1000).format('YYYY-MM-DD')
                : res.Data[item.key]
          })
        }
        pageData.spinning = false
      })
    }

    return {
      ...toRefs(pageData)
    }
  }
})
